import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { GeoPoint } from '@angular/fire/firestore';
import { GoogleMapsModule } from '@angular/google-maps';
@Component({
  selector: 'app-add-location',
  standalone: true,
  imports: [GoogleMapsModule],
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.css'],
})
export class AddLocationComponent implements OnChanges {
  @Input() label: string = 'Location';
  @Input() description: string = 'Select a location on the map';
  @Input() location: GeoPoint | undefined;
  @Output() locationChange = new EventEmitter<GeoPoint | null>();

  options: google.maps.MapOptions = {
    mapId: 'b45898a1f3fbad8919f6191f',
    mapTypeId: 'roadmap',
    zoomControl: true,
    // center: { lat: 25.2697, lng: 55.3095 },
    scrollwheel: true,
    disableDoubleClickZoom: false,
    zoom: 8,
    fullscreenControl: false,
    streetViewControl: false,
  };

  getChurchMarkerContent(): HTMLElement | null {
    if (typeof document !== 'undefined') {
      const img = document.createElement('img');
      img.src = 'assets/markers/marker_church.png';
      img.style.width = '28px';
      img.style.height = '34px';
      return img;
    }
    return null;
  }

  markerOptions: google.maps.marker.AdvancedMarkerElementOptions = {
    gmpDraggable: true,
  };
  markerContent: HTMLElement | null = null;
  markerPosition: google.maps.LatLngLiteral | null = null;

  constructor(private cdr: ChangeDetectorRef) {
    this.markerContent = this.getChurchMarkerContent();
    const hasValidLocation = this.location && typeof this.location === 'object' && 'latitude' in this.location;
    this.options = {
      ...this.options,
      center: {
        lat: hasValidLocation ? (this.location as any).latitude : 25.2697,
        lng: hasValidLocation ? (this.location as any).longitude : 55.3095,
      },
    };
    if (hasValidLocation) {
      this.markerPosition = {
        lat: (this.location as any).latitude,
        lng: (this.location as any).longitude,
      };
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasValidLocation = this.location && typeof this.location === 'object' && 'latitude' in this.location;
    if (hasValidLocation) {
      if (!this.markerContent) {
        this.markerContent = this.getChurchMarkerContent();
      }
      this.options = {
        ...this.options,
        center: {
          lat: (this.location as any).latitude,
          lng: (this.location as any).longitude,
        },
      };
      this.markerPosition = {
        lat: (this.location as any).latitude,
        lng: (this.location as any).longitude,
      };
      this.cdr.detectChanges();
    }
  }

  clearMarker() {
    this.markerPosition = null;
    this.locationChange.emit(null);
  }

  addMarker(event: google.maps.MapMouseEvent) {
    if (event?.latLng?.toJSON()) this.markerPosition = event!.latLng!.toJSON();
    this.locationChange.emit(
      new GeoPoint(this.markerPosition?.lat!, this.markerPosition?.lng!),
    );
  }
  moveMap($event: google.maps.MapMouseEvent | google.maps.IconMouseEvent) {
    // console.log($event?.latLng?.toJSON());
  }
}
